import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getFetchCartOptions from "../../../carts/v2/fetch/get-options";
import getCartQueryKey from "../../../carts/v2/get-query-key";
import getFulfillmentOfferings from "../api-calls/fetch";
import getFulfillmentOfferingsQueryKey from "../get-query-key";
var getFetchShipOfferingsOptions = function getFetchShipOfferingsOptions(_ref) {
  var skuId = _ref.skuId,
    productId = _ref.productId,
    postalCode = _ref.postalCode,
    queryClient = _ref.queryClient;
  var offeringTypes = 'SHIP';
  return {
    queryKey: getFulfillmentOfferingsQueryKey({
      skuId: skuId,
      productId: productId,
      postalCode: postalCode,
      offeringTypes: offeringTypes,
      queryClient: queryClient
    }),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cart, _cart, currency;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Try to get cart from cache first to avoid refetching
              cart = queryClient.getQueryData(getCartQueryKey()); // Only fetch if not in cache
              if (cart) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return queryClient.fetchQuery(getFetchCartOptions({
                queryClient: queryClient
              }));
            case 1:
              cart = _context.sent;
            case 2:
              _cart = cart, currency = _cart.currency;
              return _context.abrupt("return", getFulfillmentOfferings({
                skuId: skuId,
                productId: productId,
                postalCode: postalCode,
                offeringTypes: offeringTypes,
                currency: currency
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: Infinity,
    // Data never goes stale (prevents auto-refetches)
    retry: false,
    // Don't retry on initial failure
    retryOnMount: false,
    // KEY: Don't retry failed queries when new components mount
    gcTime: Infinity // Keep error/success data in cache forever
  };
};
export default getFetchShipOfferingsOptions;